import type { RoundStatus } from '@kaeliux/shared';
import { authedPost } from './http';
import { normalizeRoundStatus } from './sunControlNormalization';

/**
 * The round banner's data — `/getRoundStatus`, which also nudges the
 * server-side round evaluator when a deadline has passed. Mock mode swaps
 * this file for `services/mock/round.service.ts`.
 */
export async function getRoundStatus(): Promise<RoundStatus> {
    return normalizeRoundStatus(await authedPost<unknown>('/getRoundStatus', {}));
}
